// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__3uBX9","skeleton--animation":"Skeleton_skeleton--animation__3Esi4","skeleton-animation":"Skeleton_skeleton-animation__5Nd9W"};